module.exports = __webpack_public_path__ + "media/images/favicon-7f137054488ce01a3b5a908cd4761a70.ico";